import { windowChannel } from './windowChannel';
/**
 * Role discovery over the window channel. A window that plays a role (the
 * viewer popout, the report popout, the worklist) answers PINGs with a PONG
 * carrying its role; anyone about to open a window first asks whether a live
 * one already exists so it can navigate it in place (no reload, no duplicate
 * window) instead of window.open-ing another copy of the app.
 */
/**
 * Answer PINGs with this window's role (plus optional live context, e.g. the
 * currently displayed studyId). Returns an unsubscribe function; keep it
 * mounted for the lifetime of the surface (a React effect is the right home).
 */
export function answerPings(role, getContext) {
    return windowChannel.on('PING', () => {
        // windowName lets a discoverer address ONE window of a multi-viewer fleet
        // (per-monitor hanging protocols) — plain role discovery can't tell
        // 'newlumen-viewer' from 'newlumen-viewer-2'.
        windowChannel.pong({ role, windowName: window.name || undefined, ...getContext?.() });
    });
}
/**
 * True when a live window of the given role answers within `timeoutMs`.
 * BroadcastChannel delivery is near-instant on the same machine; the timeout
 * only bounds the "nobody is there" case, so keep it short — every study
 * open in multi-monitor mode waits on this before falling back to
 * window.open.
 */
export function discoverWindow(role, timeoutMs = 300, windowName) {
    return new Promise((resolve) => {
        let settled = false;
        const unsubscribe = windowChannel.on('PONG', (message) => {
            if (settled)
                return;
            const payload = message.payload;
            if (payload?.role !== role)
                return;
            // When a specific window is sought, only that window's PONG counts.
            if (windowName && payload?.windowName !== windowName)
                return;
            settled = true;
            unsubscribe();
            clearTimeout(timer);
            resolve(true);
        });
        const timer = setTimeout(() => {
            if (settled)
                return;
            settled = true;
            unsubscribe();
            resolve(false);
        }, timeoutMs);
        windowChannel.ping();
    });
}
